import type { SDKHostCallbacks } from './public-types'

export function createEmptyCallbacks(): SDKHostCallbacks {
  return {
    onReady: undefined,
    onNavigate: undefined,
    onCallback: undefined,
  }
}